import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CallbackComponent } from "./authentication/components/callback/callback.component";
import { LoginComponent } from "./authentication/components/login/login.component";
import { SsoLogoutComponent } from "./authentication/components/sso-logout/sso-logout.component";
import { SecurityGuard } from "./authentication/guards/security.guard";
import { AccessDeniedComponent } from "./authentication/components/access-denied/access-denied.component";

const routes: Routes = [
  { path: "", redirectTo: "mdm", pathMatch: "full" },
  {
    path: "login",
    data: {
      title: "Login",
    },
    component: LoginComponent,
  },
  {
    path: "logout",
    data: {
      title: "Logout",
    },
    component: SsoLogoutComponent,
  },
  {
    path: "callback",
    data: {
      title: "Callback",
    },
    component: CallbackComponent,
  },
  {
    path: "access-denied",
    data: {
      title: "Access Denied",
    },
    component: AccessDeniedComponent,
  },
  {
    path: "mdm",
    canActivate: [SecurityGuard],
    loadChildren: () => import("./mobile-application-manager/mobile-application-manager.module").then((m) => m.MobileApplicationDashboardModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
